import store from "store/store";


export const columnsSelectors = {
	awards: (state = store.getState()) => state.columns.awards,
	projects: (state = store.getState()) => state.columns.projects,
	proposals: (state = store.getState()) => state.columns.proposals,
	subawards: (state = store.getState()) => state.columns.subawards,
	modifications: (state = store.getState()) => state.columns.modifications,
	subawardModifications: (state = store.getState()) => state.columns.subawardModifications,
};
